import { botPersonality } from './botPersonality.js';

const BOT_PALETTES = {
  trend: {
    key: 'trend',
    icon: 'trend',
    role: 'Trend watcher',
    avatar: 'bg-blue-100 text-blue-700 ring-blue-200 dark:bg-blue-950 dark:text-blue-200 dark:ring-blue-800',
    accent: 'bg-gradient-to-r from-blue-500 to-cyan-400',
  },
  momentum: {
    key: 'momentum',
    icon: 'momentum',
    role: 'Momentum watcher',
    avatar: 'bg-violet-100 text-violet-700 ring-violet-200 dark:bg-violet-950 dark:text-violet-200 dark:ring-violet-800',
    accent: 'bg-gradient-to-r from-violet-500 to-fuchsia-400',
  },
  reversion: {
    key: 'reversion',
    icon: 'reversion',
    role: 'Price-balance watcher',
    avatar: 'bg-emerald-100 text-emerald-700 ring-emerald-200 dark:bg-emerald-950 dark:text-emerald-200 dark:ring-emerald-800',
    accent: 'bg-gradient-to-r from-emerald-500 to-teal-400',
  },
  crossover: {
    key: 'crossover',
    icon: 'crossover',
    role: 'Trend-change watcher',
    avatar: 'bg-amber-100 text-amber-800 ring-amber-200 dark:bg-amber-950 dark:text-amber-200 dark:ring-amber-800',
    accent: 'bg-gradient-to-r from-amber-500 to-orange-400',
  },
  breakdown: {
    key: 'breakdown', icon: 'breakdown', role: 'Breakdown watcher',
    avatar: 'bg-rose-100 text-rose-700 ring-rose-200 dark:bg-rose-950 dark:text-rose-200 dark:ring-rose-800',
    accent: 'bg-gradient-to-r from-rose-500 to-pink-400',
  },
  experiment: {
    key: 'experiment', icon: 'experiment', role: 'Trend confirmation watcher',
    avatar: 'bg-sky-100 text-sky-700 ring-sky-200 dark:bg-sky-950 dark:text-sky-200 dark:ring-sky-800',
    accent: 'bg-gradient-to-r from-sky-500 to-blue-400',
  },
  classic: {
    key: 'classic',
    icon: 'classic',
    role: 'Technical watcher',
    avatar: 'bg-slate-200 text-slate-700 ring-slate-300 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700',
    accent: 'bg-gradient-to-r from-slate-500 to-slate-300',
  },
  custom: {
    key: 'custom', icon: 'bot', role: 'Strategy watcher',
    avatar: 'bg-purple-100 text-purple-700 ring-purple-200 dark:bg-purple-950 dark:text-purple-200 dark:ring-purple-800',
    accent: 'bg-gradient-to-r from-purple-500 to-violet-400',
  },
};

export const botVisualIdentity = (bot = {}) => {
  const strategy = String(
    bot.trading_strategy_name
    || bot.strategy_name
    || bot.trading_strategy_family
    || '',
  ).trim();
  const personality = botPersonality(bot);
  return { ...BOT_PALETTES[personality.key], strategy: strategy || personality.label };
};
